// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * Office/aanbieder-gegevens voor autocomplete + automatische aanvulling.
 *
 * Bewust LEEG gelaten: er is (nog) geen betrouwbare, geverifieerde bron voor de
 * contactgegevens van notariskantoren of uitvaartondernemingen. Er worden geen
 * gegevens verzonnen. Zodra een betrouwbare lijst beschikbaar is, kan die hier
 * worden gekoppeld; de pagina's vullen dan automatisch in wat aanwezig is.
 * Adres (straat/plaats) wordt los hiervan al automatisch aangevuld via postcode
 * en huisnummer met de bestaande adrescontrole (PDOK).
 */
export interface OfficeRecord {
  name:         string
  street?:      string
  houseNumber?: string
  postalCode?:  string
  city?:        string
  phone?:       string
  email?:       string
  website?:     string
}

export const NOTARY_OFFICES: OfficeRecord[] = []
export const FUNERAL_PROVIDERS: OfficeRecord[] = []

/** Zoekt een record op exacte naam (case-insensitief). Leeg → undefined. */
export function findOffice(list: OfficeRecord[], name: string): OfficeRecord | undefined {
  const q = name.trim().toLowerCase()
  if (!q) return undefined
  return list.find(o => o.name.toLowerCase() === q)
}
